import React, { useState } from "react";
import { FaEnvelope } from "react-icons/fa";
import Logo from "../../assets/login/Logo.png";
import BgImage from "../../assets/login/image.JPG";

function ForgotPassword() {
  const [email, setEmail] = useState("");

  return (
    <div className="min-h-screen w-full relative overflow-hidden">
      {/* Background layers */}
      <div className="absolute inset-0 bg-[#000c1d]/90" />
      <div
        className="absolute inset-0 opacity-60"
        style={{
          backgroundImage: `url(${BgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      {/* Main Content */}
      <div className="relative z-10 container mx-auto px-4 py-8 md:py-12 lg:py-16 min-h-screen flex items-center justify-center">
        <div className="w-full max-w-5xl bg-transparent">
          <div className="grid md:grid-cols-2 gap-0 h-full">
            {/* Left Side - Welcome Section */}
            <div className="bg-[#0055b8] p-4 sm:p-6 md:p-8 rounded-lg text-white flex flex-col items-center order-2 md:order-1 md:block hidden h-full">
              <h2 className="text-xl sm:text-2xl font-semibold mb-4 sm:mb-6 md:mb-8 text-center">
                Welcome to
              </h2>
              <img
                src={Logo}
                alt="Smart Coaches Logo"
                className="w-48 sm:w-56 md:w-64 h-auto mb-4 sm:mb-6 mx-auto"
              />
              <h1 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 text-center">
                Novius Hot Axle Hot Wheel Detection System
              </h1>
              <p className="text-center text-sm sm:text-base mb-8 sm:mb-10 md:mb-12 px-2 sm:px-4">
                Novius HAHW is dedicated to providing quality and continuous
                process improvement for both customers and employees.
              </p>
              <div className="mt-auto flex flex-col lg:flex-row gap-2 sm:gap-4 text-xs sm:text-sm text-center justify-center">
                <a href="#about" className="hover:underline whitespace-nowrap">
                  ABOUT NOVIUS HAHW
                </a>
                <span className="hidden sm:hidden lg:inline">|</span>
                <a
                  href="#contact"
                  className="hover:underline whitespace-nowrap"
                >
                  CONTACT US
                </a>
                <span className="hidden sm:hidden lg:inline">|</span>
                <a href="#about" className="hover:underline whitespace-nowrap">
                  ABOUT US
                </a>
              </div>
            </div>

            {/* Right Side - Forgot Password Form */}
            <div className="bg-transparent p-4 sm:p-6 md:p-8 order-1 md:order-2 backdrop-blur-md bg-white/30 md:bg-transparent flex flex-col items-center justify-center w-full h-full">
              <h2 className="text-xl sm:text-2xl font-bold text-white mb-6 sm:mb-8">
                Forgot Password
              </h2>
              <form className="space-y-4 sm:space-y-6 w-full max-w-md">
                {/* Email Input */}
                <div className="relative space-y-2">
                  <label className="text-white text-sm sm:text-base">
                    Email Address
                  </label>
                  <div className="flex items-center">
                    <FaEnvelope className="absolute left-3 text-gray-500" />
                    <input
                      type="email"
                      className="w-full px-10 sm:px-12 py-2 rounded-md bg-white/90 text-sm sm:text-base"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="w-full bg-[#3b82f6] hover:bg-[#2563eb] text-white py-2 sm:py-3 rounded-md font-medium text-sm sm:text-base transition-colors"
                >
                  Submit
                </button>

                {/* Login Link */}
                <div className="mt-4 text-center">
                  <span className="text-white text-sm">
                    Remember your password?{" "}
                  </span>
                  <a
                    href="/login"
                    className="text-[#3b82f6] hover:underline text-sm"
                  >
                    Login Here
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
